import {defineStore} from "pinia";
import {api} from "@/configs";
import {apiUrls} from "@/constants";
import Swal from "sweetalert2";
import { getErrorMessage} from "@/utils/errorHandler";

export const useCampaignStore = defineStore("campaign", {
    state: () => ({
        campaigns: []
    }),

    actions: {
        async fetchCampaigns() {
            try {
                const response = await api.get(apiUrls.campaign);
                 this.campaigns = response.data?.data ?? []
            } catch (error) {
                this.campaigns = [];
            }
        },

        async addCampaign(payload) {
            try {
                await api.post(apiUrls.campaign, payload, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                });

                await this.fetchCampaigns();
                await Swal.fire("Campaign Added Successfully", "", "success");
                return true;
            } catch (error) {

                // Safely extract and format the error message
                const errorMessage = getErrorMessage(error, "Failed to add campaign. Please try again.");

                await Swal.fire("Failed to add campaign.", errorMessage, "error");
                return false;
            }
        },

        async updateCampaign(campaignId, payload) {
            try {
                const formData = new FormData();
                formData.append("_method", "PATCH");

                Object.keys(payload).forEach((key) => {
                    if (payload[key] !== null && payload[key] !== undefined) {
                        formData.append(key, payload[key]);
                    }
                });

                await api.post(`${apiUrls.campaign}/${campaignId}`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                });

                await this.fetchCampaigns();

                await Swal.fire("Campaign Updated Successfully", "", "success");
                return true;
            } catch (error) {
                const errorMessage = getErrorMessage(error, "Failed to add campaign. Please try again.");
                await Swal.fire("Failed to update campaign", errorMessage, "error");
                return false;
            }
        },

        async updateCampaignStatus(campaignId) {
            try {

                await api.patch(`${apiUrls.campaign}/${campaignId}/status`);

                await this.fetchCampaigns();

                await Swal.fire("Campaign Status Updated", "", "success");
                return true;
            } catch (error) {

                await Swal.fire("Failed to update campaign status", "", "error");
                return false;
            }
        }

    }

});